(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-input-with-type"] = factory(require("vue"));
	else
		root["vue-input-with-type"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__203__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 477:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __nested_webpack_require_530__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_530__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_530__.o(definition, key) && !__nested_webpack_require_530__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_530__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_530__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};

// EXPORTS
__nested_webpack_require_530__.d(__nested_webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_530__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCurrencyInput.vue?vue&type=template&id=0c546259&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-currency-input",class:{ 'sf-currency-input--postfixed': _vm.postfix, 'sf-currency-input--error': _vm.hasError, 'sf-currency-input--focused': _vm.isFocused }},[(_vm.label)?_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"sf-currency-input__wrapper",style:({ maxWidth: _vm.maxWidthStyle })},[_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],ref:"currency-input",staticClass:"sf-currency-input__field",class:{ 'sr-only': _vm.$attrs['readonly'], 'sf-currency-input__field--error': _vm.hasError },style:({ paddingRight: _vm.paddingRight + 'px' }),attrs:{"id":_vm.uuid,"type":"tel","aria-invalid":_vm.hasError ? 'true' : false,"aria-labelledby":_vm.label ? _vm.uuid + '-label' : false,"aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false,"maxlength":_vm.maxLength},domProps:{"value":(_vm.model)},on:{"keyup":function($event){return _vm.formatString($event.target.value)},"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false},"input":function($event){if($event.target.composing)return;_vm.model=$event.target.value}}},'input',_vm.$attrs,false),_vm.inputListeners)),(_vm.$attrs['readonly'])?_c('span',{staticClass:"sf-currency-input__value",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.formatText(_vm.value))),(_vm.postfix)?[_vm._v(" ")]:_vm._e()],2):_vm._e(),(_vm.postfix)?_c('span',{staticClass:"sf-currency-input__postfix"},[_vm._v(_vm._s(_vm.postfix))]):_vm._e()]),(_vm.addon)?_c('i',{attrs:{"id":_vm.computedAddonId}},[_c('span',{staticClass:"sf-currency-input__addon"},[_vm._v(_vm._s(_vm.addon))])]):_vm._e()])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueCurrencyInput.vue?vue&type=script&lang=js&


const DELIMITERS = { en: [',', '\\.'], hu: [' ', ','] };
/* harmony default export */ const VueCurrencyInputvue_type_script_lang_js_ = ({
	mixins: [c, N, a],
	inheritAttrs: false,
	name: 'VueCurrencyInput',
	data: () => ({
		model: null,
		isFocused: false
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		Text of the label
		*/
		label: {
			required: false,
			type: String
		},
		/**
		The maximum width of the input
		 */
		maxWidth: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		Native maxlength attribute of input
		 */
		maxLength: {
			type: Number
		},
		/**
		postfix text of the input
		 */
		postfix: {
			type: String,
			required: false
		},
		/**
		Grouping/formatting values with spaces (# ### ### ###)
		 */
		isGrouped: {
			type: Boolean,
			required: false,
			default: true
		},
		/**
		Number of allowed decimals
		 */
		decimals: {
			type: Number,
			required: false,
			default: 0
		},
		/**
		Add padding right in inline-style onto the input
		 */
		paddingRight: {
			type: Number,
			reqired: false,
			default: 0
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val <= Number.MAX_SAFE_INTEGER) {
					this.formatNumber(val);
				}
			},
			immediate: true
		}
	},
	computed: {
		inputListeners() {
			return Object.assign({}, this.$listeners, {
				input() {
					return;
				}
			});
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		}
	},
	methods: {
		formatString(value) {
			let regexp = new RegExp(`[^0-9${this.decimalDelimiter}]`, 'g');
			let parsedValue = (value + '').replace(regexp, '');
			const formattedValueMatch = parsedValue.match(new RegExp(`(\\d+)(${this.decimalDelimiter}?)(\\d{0,${this.decimals}})\\d*`));
			let formattedValue = '';
			if (formattedValueMatch) {
				if (formattedValueMatch[1] <= Number.MAX_SAFE_INTEGER) {
					formattedValue =
						new Intl.NumberFormat(this.$i18n.locale, {
							minimumFractionDigits: 0,
							maximumFractionDigits: this.decimals,
							useGrouping: this.isGrouped
						}).format(formattedValueMatch[1]) + `${formattedValueMatch[2]}${formattedValueMatch[3]}`;
					this.model = formattedValue;
					this.$emit('input', this.parse(value));
				} else {
					this.model = this.formatBigInt(formattedValueMatch[1]);
					this.$emit('input', formattedValueMatch[1]);
				}
			}
		},
		formatBigInt(bigInt) {
			let result = '';
			for (let i = bigInt.length - 1; i >= 0; i -= 3) {
				result = bigInt.substring(Math.max(i - 2, 0), i + 1) + (result && ' ' + result);
			}
			return result;
		},
		formatNumber(value) {
			let formattedValue = '';
			if (value || value === 0) {
				formattedValue = new Intl.NumberFormat(this.$i18n.locale, {
					minimumFractionDigits: 0,
					maximumFractionDigits: this.decimals,
					useGrouping: this.isGrouped
				}).format(value);
				if (Number.isNaN(formattedValue)) {
					formattedValue = '';
				}
			}
			this.model = formattedValue;
		},
		formatText(value) {
			return new Intl.NumberFormat(this.$i18n.locale, {
				minimumFractionDigits: 0,
				maximumFractionDigits: this.decimals,
				useGrouping: this.isGrouped
			}).format(value);
		},
		parse(value) {
			let regexp = new RegExp(`[^0-9${this.decimalDelimiter}]`, 'g');
			let regexpDelimiter = new RegExp(this.decimalDelimiter, 'g');
			let parsedValue = (value + '').replace(regexp, '').replace(regexpDelimiter, '.');
			let numericvalue = parseFloat(parsedValue);
			if (!isNaN(numericvalue)) {
				return Number.isInteger(numericvalue) ? numericvalue : +numericvalue.toFixed(this.decimals);
			} else {
				return null;
			}
		}
	},
	created() {
		let delimiter = DELIMITERS[this.$i18n.locale];
		this.thousandDelimiter = delimiter[0];
		this.decimalDelimiter = delimiter[1];
	}
});

;// CONCATENATED MODULE: ./src/components/VueCurrencyInput.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueCurrencyInputvue_type_script_lang_js_ = (VueCurrencyInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueCurrencyInput.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueCurrencyInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "0c546259",
  null
  
)

/* harmony default export */ const VueCurrencyInput = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueCurrencyInput);


__nested_webpack_exports__ = __nested_webpack_exports__["default"];
/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-currency-input.umd.js.map

/***/ }),

/***/ 194:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __nested_webpack_require_512__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_512__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_512__.o(definition, key) && !__nested_webpack_require_512__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_512__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_512__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};

// EXPORTS
__nested_webpack_require_512__.d(__nested_webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_512__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInput.vue?vue&type=template&id=7c061b16&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-input",class:{ 'sf-input--prefixed': _vm.prefix, 'sf-input--postfixed': _vm.postfix, 'sf-input--error': _vm.hasError, 'sf-input--focused': _vm.isFocused }},[(_vm.label && _vm.hasTooltipSlot)?[_c('div',{staticClass:"sf-input__label"},[_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]),_vm._t("tooltip")],2)]:(_vm.label && !_vm.hasTooltipSlot)?[_c('label',{attrs:{"id":_vm.uuid + '-label',"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))])]:void 0,_c('div',{staticClass:"sf-input__wrapper",style:({ maxWidth: _vm.maxWidthStyle })},[_c('input',_vm._g(_vm._b({ref:"input",class:{ 'sr-only': _vm.$attrs['readonly'] },style:({ paddingRight: _vm.paddingRight + 'px' }),attrs:{"id":_vm.uuid,"type":_vm.type,"aria-invalid":_vm.hasError ? 'true' : false,"aria-labelledby":_vm.label ? _vm.uuid + '-label' : false,"aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false}}},'input',_vm.$attrs,false),_vm.inputListeners)),(_vm.prefix)?_c('span',{staticClass:"sf-input__prefix",attrs:{"id":_vm.computedPrefixId}},[_vm._v(_vm._s(_vm.prefix)),_c('span',{staticClass:"sr-only"},[_vm._v("nélkül")])]):_vm._e(),(_vm.$attrs['readonly'])?_c('span',{staticClass:"sf-input__value",attrs:{"aria-hidden":"true"}},[(_vm.prefix)?[_vm._v(" ")]:_vm._e(),_vm._v(_vm._s(_vm.value)),(_vm.postfix)?[_vm._v(" ")]:_vm._e()],2):_vm._e(),(_vm.postfix)?_c('span',{staticClass:"sf-input__postfix"},[_vm._v(_vm._s(_vm.postfix))]):_vm._e()]),(_vm.addon || _vm.hasCounter)?_c('i',{style:(_vm.maxWidthStyle),attrs:{"id":_vm.computedAddonId}},[(_vm.addon)?_c('span',{staticClass:"sf-input__addon"},[_vm._v(_vm._s(_vm.addon))]):_vm._e(),(_vm.hasCounter)?_c('span',{staticClass:"sf-input__counter"},[_vm._v(_vm._s(this.value && this.value.length || 0)),(_vm.maxLength)?[_vm._v("/"+_vm._s(_vm.maxLength))]:_vm._e()],2):_vm._e()]):_vm._e()],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInput.vue?vue&type=script&lang=js&


/* harmony default export */ const VueInputvue_type_script_lang_js_ = ({
	mixins: [c, N, a],
	inheritAttrs: false,
	name: 'VueInput',
	data: () => ({
		isFocused: false
	}),
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * Type of the input
		 */
		type: {
			required: false,
			default: 'text',
			type: String
		},
		/**
		 * Label of the input
		 */
		label: {
			required: false,
			type: String
		},
		/**
		The maximum width of the input
		*/
		maxWidth: {
			type: Number
		},
		/**
		Native maxlength attribute of input
		*/
		maxLength: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		postfix text of the input
		*/
		postfix: {
			type: String,
			required: false
		},
		/**
		prefix text of the input
		*/
		prefix: {
			type: String,
			required: false
		},
		/**
		If true charachter counter appears on input
		*/
		hasCounter: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		Add padding right in inline-style onto the input
		*/
		paddingRight: {
			type: Number,
			reqired: false,
			default: 0
		}
	},
	computed: {
		inputListeners() {
			const vm = this;
			return Object.assign({}, this.$listeners, {
				input(event) {
					vm.$emit('input', event.target.value);
					if (event.target.value.length == vm.maxLength) {
						vm.$emit('maxlength-reached');
					}
				}
			});
		},
		hasTooltipSlot() {
			return !!this.$slots['tooltip'];
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		},
		addonMaxWidthStyle() {
			return this.hasCounter ? `max-width: ${this.maxWidth}px` : null;
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueInput.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueInputvue_type_script_lang_js_ = (VueInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueInput.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7c061b16",
  null
  
)

/* harmony default export */ const VueInput = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueInput);


__nested_webpack_exports__ = __nested_webpack_exports__["default"];
/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-input.umd.js.map

/***/ }),

/***/ 904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(203));
	else {}
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__203__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 322:
/***/ (() => {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

(function() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    var ce = new window.CustomEvent('test', { cancelable: true });
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
      // IE has problems with .preventDefault() on custom events
      // http://stackoverflow.com/questions/23349191
      throw new Error('Could not prevent default');
    }
  } catch (e) {
    var CustomEvent = function(event, params) {
      var evt, origPrevent;
      params = params || {};
      params.bubbles = !!params.bubbles;
      params.cancelable = !!params.cancelable;

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      origPrevent = evt.preventDefault;
      evt.preventDefault = function() {
        origPrevent.call(this);
        try {
          Object.defineProperty(this, 'defaultPrevented', {
            get: function() {
              return true;
            }
          });
        } catch (e) {
          this.defaultPrevented = true;
        }
      };
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent; // expose definition to window
  }
})();


/***/ }),

/***/ 570:
/***/ (function(module) {

!function(e,n){  true?module.exports=n():0}(this,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,r=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function i(e){var n=e.event,t=e.handler;(0,e.middleware)(n)&&t(n)}function a(n,t){var a=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||r,isActive:!(!1===e.isActive),detectIframe:!(!1===e.detectIframe),capture:!!e.capture}}(t.value),d=a.handler,o=a.middleware,c=a.detectIframe,u=a.capture;if(a.isActive){if(n[e]=a.events.map(function(e){return{event:e,srcTarget:document.documentElement,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware,d=t.composedPath&&t.composedPath()||t.path;(d?d.indexOf(n)<0:!n.contains(t.target))&&i({event:t,handler:r,middleware:a})}({el:n,event:e,handler:d,middleware:o})},capture:u}}),c){var l={event:"blur",srcTarget:window,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware;setTimeout(function(){var e=document.activeElement;e&&"IFRAME"===e.tagName&&!n.contains(e)&&i({event:t,handler:r,middleware:a})},0)}({el:n,event:e,handler:d,middleware:o})},capture:u};n[e]=[].concat(n[e],[l])}n[e].forEach(function(t){var r=t.event,i=t.srcTarget,a=t.handler;return setTimeout(function(){n[e]&&i.addEventListener(r,a,u)},0)})}}function d(n){(n[e]||[]).forEach(function(e){return e.srcTarget.removeEventListener(e.event,e.handler,e.capture)}),delete n[e]}var o=n?{bind:a,update:function(e,n){var t=n.value,r=n.oldValue;JSON.stringify(t)!==JSON.stringify(r)&&(d(e),a(e,{value:t}))},unbind:d}:{};return{install:function(e){e.directive("click-outside",o)},directive:o}});
//# sourceMappingURL=v-click-outside.umd.js.map


/***/ }),

/***/ 203:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_4388__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_4388__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__nested_webpack_require_4388__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__nested_webpack_require_4388__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_4388__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_4388__.o(definition, key) && !__nested_webpack_require_4388__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_4388__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_4388__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_4388__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_4388__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_4388__.d(__nested_webpack_exports__, {
  VueSelect: () => (/* reexport */ VueSelect),
  VueSelectOption: () => (/* reexport */ VueOption)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_4388__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueSelect.vue?vue&type=template&id=46fd2e45&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.vcoConfig),expression:"vcoConfig"}],ref:"select",staticClass:"sf-select",class:{ 'sf-select--error': _vm.hasError, 'sf-select--open': _vm.dropdownVisible, 'sf-select--up': _vm.upperList, 'sf-select--focused': _vm.isFocused },style:({ maxWidth: _vm.maxWidthStyle })},[_c('div',{staticClass:"sf-select__button-wrapper"},[(_vm.label)?_c('label',{staticClass:"sf-select__label",attrs:{"id":_vm.integratedLabelId,"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('button',{ref:"button",staticClass:"sf-select__button",class:_vm.buttonOpenClass,attrs:{"id":_vm.id,"type":"button","aria-haspopup":"listbox","aria-labelledby":_vm.ariaLabelledBy,"aria-describedby":_vm.describedBy,"aria-expanded":_vm.dropdownVisible,"aria-invalid":_vm.hasError,"disabled":_vm.disabled},on:{"blur":_vm.onBlur,"click":_vm.open,"focus":function($event){_vm.isFocused = true}}},[_c('span',{staticClass:"sf-select__button-text",attrs:{"id":`${_vm.uuid}__button-text`},domProps:{"innerHTML":_vm._s(_vm.getText(_vm.focusedIndex))}})])]),_c('div',{ref:"selectOptionsWrapper",staticClass:"sf-select__options-wrapper"},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.dropdownVisible),expression:"dropdownVisible"}],ref:"listbox",staticClass:"sf-select__options",attrs:{"tabindex":"-1","role":"listbox","aria-labelledby":_vm.ariaLabelledBy,"aria-activedescendant":_vm.focusedId},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();$event.stopPropagation();return _vm.selectWithEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;$event.stopPropagation();return _vm.moveDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"]))return null;$event.stopPropagation();return _vm.moveUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;$event.stopPropagation();return _vm.close()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab"))return null;$event.stopPropagation();return _vm.closeOnTab.apply(null, arguments)}]}},[_vm._t("default",null,{"focusedIndex":_vm.focusedIndex})],2)])]):_c('div',{staticClass:"sf-select-wrapper",class:{ 'sf-select--error': _vm.hasError },style:({ maxWidth: _vm.maxWidthStyle })},[(_vm.label)?_c('label',{staticClass:"sf-select__label",attrs:{"id":_vm.integratedLabelId,"for":_vm.uuid}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('select',{ref:"nativeSelect",staticClass:"sf-select__native",attrs:{"id":_vm.uuid,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.changeOptionNative,"blur":function($event){return _vm.$emit('blur')}}},[(_vm.placeholder)?_c('option',{ref:"placeholder",attrs:{"selected":"selected","default":"","value":"","hidden":""}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._t("default",null,{"focusedIndex":_vm.focusedIndex})],2)])
}
var staticRenderFns = []


// EXTERNAL MODULE: ../../node_modules/custom-event-polyfill/polyfill.js
var polyfill = __nested_webpack_require_4388__(322);
// EXTERNAL MODULE: ../../node_modules/v-click-outside/dist/v-click-outside.umd.js
var v_click_outside_umd = __nested_webpack_require_4388__(570);
var v_click_outside_umd_default = /*#__PURE__*/__nested_webpack_require_4388__.n(v_click_outside_umd);
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __nested_webpack_require_4388__(203);
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__nested_webpack_require_4388__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueSelect.vue?vue&type=script&lang=js&





const SELECT_VALUE_CHANGE_EVENT = 'select-value-change';
const VueSelectvue_type_script_lang_js_outerHeight = (el) => {
	var height = el.offsetHeight;
	var style = getComputedStyle(el);

	height += parseInt(style.marginTop) + parseInt(style.marginBottom);
	return height;
};
const getElemDistance = (elem) => {
	var location = 0;
	if (elem.offsetParent) {
		do {
			location += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}
	return location >= 0 ? location : 0;
};
/* harmony default export */ const VueSelectvue_type_script_lang_js_ = ({
	name: 'VueSelect',
	inheritAttrs: false,
	data() {
		return {
			eventBus: new (external_commonjs_vue_commonjs2_vue_root_Vue_default())(),
			dropdownVisible: false,
			selected: null,
			selectedText: null,
			focusedIndex: null,
			upperList: false,
			isFocused: false,
			vcoConfig: {
				handler: this.clickOutsideSelect,
				events: ['dblclick', 'click'],
				middleware: this.clickOutsideMiddleware,
				isActive: true
			}
		};
	},
	directives: {
		clickOutside: (v_click_outside_umd_default()).directive
	},
	mixins: [a, l, c],
	props: {
		/**
		 * ID of the label
		 */
		labelId: {
			type: String,
			required: false
		},
		/**
		 * Text of the label
		 */
		label: {
			type: String,
			required: false
		},
		/**
		 * If used with v-model this prop is automatically injected
		 */
		value: {
			required: true
		},
		/**
		 * Placeholder text for the dropdown button
		 */
		placeholder: {
			type: String,
			required: false
		},
		/**
		 * Maximum width of the element
		 */
		maxWidth: {
			type: Number
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		 * Disabled state of the element
		 */
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		ariaDescribedby: {
			required: false
		}
	},
	watch: {
		value: {
			handler(val) {
				if (val == null) {
					this.focusedIndex = null;
				}
				this.eventBus.$emit('value-changed', { id: this.uuid, value: this.value });
			},
			immediate: true
		},
		dropdownVisible(val) {
			this.vcoConfig.isActive = val;
		}
	},
	computed: {
		describedBy() {
			const aria = this.ariaDescribedby ? ` ${this.ariaDescribedby}` : '';
			return `${this.uuid}__button-text${aria}`;
		},
		integratedLabelId() {
			return this.label ? `${this.uuid}-label` : '';
		},
		ariaLabelledBy() {
			if (this.labelId) {
				return this.labelId;
			} else if (this.integratedLabelId) {
				return this.integratedLabelId;
			} else {
				return false;
			}
		},
		focusedId() {
			let postfix = this.focusedIndex == null ? 'please' : this.focusedIndex;
			return `${this.uuid}-item-${postfix}`;
		},
		buttonOpenClass() {
			let classes = [];
			classes.push(this.$attrs['target-class']);
			if (this.dropdownVisible) {
				classes.push('sf-select__button--open');
			}
			return classes;
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		}
	},
	methods: {
		getText(index) {
			let text;
			if (index == null) {
				text = this.placeholder || '&nbsp;';
			} else {
				text = this.selectedText;
			}
			return text;
		},
		dispatchSelectEvent() {
			const formId = this.isMobile ? this.$refs.nativeSelect?.form?.id : this.$refs.button?.form?.id;
			const selectValueChanged = new CustomEvent(SELECT_VALUE_CHANGE_EVENT, {
				detail: {
					id: this.uuid,
					value: this.selectedText,
					formId
				}
			});
			document.dispatchEvent(selectValueChanged);
		},
		select(index, text, value = null, emit = true, close = true) {
			this.focusedIndex = index;
			if (index == null) {
				this.selected = null;
				this.selectedText = this.placeholder;
			} else {
				this.selected = value;
				this.selectedText = text;
			}
			close && this.close();
			emit && this.$emit('input', this.selected);
			this.dropdownVisible && this.scrollToSelectedItem();
		},
		selectWithEnter() {
			this.dispatchSelectEvent();
			this.close();
		},
		closeOnTab() {
			this.close(true);
		},
		clickOutsideMiddleware() {
			return this.dropdownVisible;
		},
		clickOutsideSelect() {
			this.close();
			this.emitBlur();
		},
		emitBlur() {
			this.$emit('blur');
			this.isFocused = false;
		},
		async onBlur() {
			await this.$nextTick();
			if (!this.dropdownVisible) {
				this.emitBlur();
			}
		},
		scrollToSelectedItem() {
			this.$nextTick(() => {
				const focusableItem = this.focusedIndex == null ? this.$refs['placeholder'] : this.$children[this.focusedIndex].$el;
				const listbox = this.$refs.listbox;
				if (focusableItem && listbox) {
					listbox.scrollTop = focusableItem.offsetTop - 56;
				}
			});
		},
		changeOptionNative() {
			const index = this.placeholder ? this.$refs.nativeSelect.selectedIndex - 1 : this.$refs.nativeSelect.selectedIndex;
			this.$emit('input', this.$children[index].value);
			this.dispatchSelectEvent();
		},
		open() {
			if (!this.dropdownVisible) {
				this.dropdownVisible = true;
				this.upperList = false;
				this.$nextTick(() => {
					this.eventBus.$emit('index-changed', { index: this.focusedIndex });
					this.$emit('list-opened', true);
					this.upperList = this.isListBottomOutOfScreen();
					setTimeout(() => {
						this.$refs.listbox.focus();
					});
				});
			} else {
				this.close();
			}
		},
		close(dontToggleFocus) {
			if (this.dropdownVisible) {
				this.dropdownVisible = false;
				this.$emit('input', this.selected);
				this.$emit('list-opened', false);
				if (!dontToggleFocus) {
					setTimeout(() => {
						this.$refs.button.focus();
					});
				}
			}
		},
		getNextFocusableIndex() {
			return this.$children.findIndex((item, index) => (this.focusedIndex == null || index > this.focusedIndex) && !item.disabled);
		},
		getPrevFocusableIndex() {
			let optionsLength = this.$children.length;
			let indexedItems = this.$children.map((element, index) => {
				element.oriIndex = index;
				return element;
			});

			let lastItem = indexedItems.reverse().find((item, index) => {
				return (this.focusedIndex == null || index > optionsLength - 1 - this.focusedIndex) && !item.disabled;
			});

			return !lastItem ? -1 : lastItem.oriIndex;
		},
		moveDown(e) {
			if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
				e.preventDefault();
			}
			let focusedIndex = this.getNextFocusableIndex();
			if (focusedIndex != -1) {
				this.focusedIndex = focusedIndex;
				this.eventBus.$emit('index-changed', { id: this.uuid, index: this.focusedIndex });
			}
		},
		moveUp(e) {
			if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
				e.preventDefault();
			}
			if (this.focusedIndex != null) {
				if (this.focusedIndex == 0 && this.placeholder) {
					this.focusedIndex = null;
					this.scrollToSelectedItem();
				} else {
					let focusedIndex = this.getPrevFocusableIndex();
					if (focusedIndex != -1) {
						this.focusedIndex = focusedIndex;
					} else if (this.placeholder) {
						this.focusedIndex = null;
						this.scrollToSelectedItem();
					}
				}
			}
			this.eventBus.$emit('index-changed', { id: this.uuid, index: this.focusedIndex, emit: !this.dropdownVisible });
		},
		isListBottomOutOfScreen() {
			if (this.$refs.listbox) {
				const listBoxBounding = this.$refs.listbox.getBoundingClientRect();
				return listBoxBounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
			}
		},
		isScreenTooSmall() {
			if (this.$refs.listbox) {
				const scrollTop =
					window.scrollY !== undefined ? window.scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop;
				const distanceFromTop = getElemDistance(this.$refs.select);
				const listBoxHeight = VueSelectvue_type_script_lang_js_outerHeight(this.$refs.listbox);
				const distanceFromScreenTop = distanceFromTop - scrollTop;
				return listBoxHeight > distanceFromScreenTop;
			}
		},
		isListTopOutOfScreen() {
			if (this.$refs.listbox) {
				const listBoxBounding = this.$refs.listbox.getBoundingClientRect();
				return listBoxBounding.top < 0;
			}
		},
		onScroll() {
			const isBottomOutOfScreen = this.isListBottomOutOfScreen();
			const isTopOutOfScreen = this.isListTopOutOfScreen();
			const isScreenSmall = this.isScreenTooSmall();

			if (isScreenSmall) {
				this.upperList = false;
			} else if (isBottomOutOfScreen) {
				this.upperList = true;
			} else if (isTopOutOfScreen) {
				this.upperList = false;
			}
		}
	},
	created() {
		this.eventBus.$on('select', ({ id, index, value, text, emit = false, close = false }) => {
			if (id == this.uuid) {
				this.select(index, text, value, emit, close);
			}
		});
		window.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onScroll);
		if (this.label && this.labelId) {
			throw new Error(`Cannot use "label" and "labelId" props together. ${this.$vnode.tag}`);
		}
		this.$on('input', (event) => {
			const labelElement = document.querySelector(`label[for=${this.uuid}]`);
			const formElement = this.isMobile ? this.$refs.nativeSelect : this.$refs.button;
			(window.dataLayer || []).push({
				event: 'dropDownSelect',
				formElementID: labelElement ? labelElement.innerHTML : this.uuid,
				formID: (formElement.form && formElement.form.getAttribute('id')) || '',
				inputValue: event
			});
		});
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onScroll);
		this.eventBus.$off();
	},
	mounted() {
		this.eventBus.$emit('value-changed', { id: this.uuid, value: this.value });
	}
});

;// CONCATENATED MODULE: ./src/components/VueSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueSelectvue_type_script_lang_js_ = (VueSelectvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueSelect.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueSelectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "46fd2e45",
  null
  
)

/* harmony default export */ const VueSelect = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueOption.vue?vue&type=template&id=b518a8ee&scoped=true&lang=pug&
var VueOptionvue_type_template_id_b518a8ee_scoped_true_lang_pug_render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('li',{ref:`item-${_vm.index}`,staticClass:"sf-select__option",class:{ 'sf-select__option--active': _vm.index == _vm.focusedIndex, 'sf-select__option--disabled': _vm.disabled },attrs:{"role":"option","id":`${_vm.$parent.id}-item-${_vm.index}`,"aria-disabled":_vm.disabled,"aria-selected":_vm.index === _vm.focusedIndex},on:{"click":function($event){$event.stopPropagation();return _vm.select(_vm.index, _vm.value, _vm.text)}}},[_vm._t("option",function(){return [_c('span',[_vm._v(_vm._s(_vm.text))])]},{"text":_vm.text,"parentId":_vm.$parent.id,"value":_vm.value,"index":_vm.index,"selectedIndex":_vm.focusedIndex})],2):_c('option',{attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value}},[_vm._t("native-option",function(){return [[_vm._v(_vm._s(_vm.text))]]},{"text":_vm.text,"parentId":_vm.$parent.id,"value":_vm.value,"index":_vm.index,"selectedIndex":_vm.focusedIndex})],2)
}
var VueOptionvue_type_template_id_b518a8ee_scoped_true_lang_pug_staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueOption.vue?vue&type=script&lang=js&



/* harmony default export */ const VueOptionvue_type_script_lang_js_ = ({
	name: 'VueSelectOption',
	inheritAttrs: false,
	data() {
		return {
			eventBus: null,
			focusedIndex: null
		};
	},
	directives: {
		clickOutside: (v_click_outside_umd_default()).directive
	},
	props: {
		value: {
			required: true
		},
		text: {
			required: true
		},
		index: {
			required: true
		},
		disabled: {
			required: false,
			default: false
		},
		defaultSelected: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	mixins: [a],
	methods: {
		select(index, value, text) {
			if (!this.disabled) {
				this.eventBus.$emit('select', { id: this.$parent.id, index, value, text, close: true });
				this.$parent.dispatchSelectEvent();
			}
		}
	},
	created() {
		this.eventBus = this.$parent.eventBus;
		this.eventBus.$on('index-changed', ({ id, index, emit }) => {
			if (id == this.$parent.id) {
				this.focusedIndex = index;
				if (this.focusedIndex == this.index || this.focusedIndex == null) {
					this.eventBus.$emit('select', { id: this.$parent.id, index, value: this.value, text: this.text, emit });
				}
			}
		});
		this.eventBus.$on('value-changed', ({ id, value }) => {
			if (id == this.$parent.id) {
				if (value == this.value) {
					this.eventBus.$emit('index-changed', { id: this.$parent.id, index: this.index });
				} else if (value == null) {
					this.eventBus.$emit('index-changed', { id: this.$parent.id, index: null });
				}
			}
		});
		if (this.$parent.value != null) {
			this.eventBus.$emit('value-changed', { id: this.$parent.id, value: this.$parent.value });
		}
	},
	beforeDestroy() {
		this.eventBus.$off('index-changed');
		this.eventBus.$off('value-changed');
	}
});

;// CONCATENATED MODULE: ./src/components/VueOption.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueOptionvue_type_script_lang_js_ = (VueOptionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/VueOption.vue



;


/* normalize component */

var VueOption_component = normalizeComponent(
  components_VueOptionvue_type_script_lang_js_,
  VueOptionvue_type_template_id_b518a8ee_scoped_true_lang_pug_render,
  VueOptionvue_type_template_id_b518a8ee_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "b518a8ee",
  null
  
)

/* harmony default export */ const VueOption = (VueOption_component.exports);
;// CONCATENATED MODULE: ./src/components-export.js





;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



})();

/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-select.umd.js.map

/***/ }),

/***/ 203:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInputWithType.vue?vue&type=template&id=49b0eb6a&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-input-with-type",style:({ maxWidth: _vm.maxWidthStyle })},[_c('div',{staticClass:"sf-input-with-type__wrapper"},[(_vm.type == _vm.TYPES.NORMAL)?_c('VueInput',_vm._g(_vm._b({attrs:{"id":_vm.uuid,"has-error":_vm.hasError,"padding-right":_vm.maxWidthStyle,"aria-describedby":_vm.ariaDescribedBy ? _vm.ariaDescribedBy : false},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}},'VueInput',_vm.$attrs,false),_vm.inputListeners)):_vm._e(),(_vm.type == _vm.TYPES.CURRENCY)?_c('VueCurrencyInput',_vm._g(_vm._b({attrs:{"id":_vm.uuid,"has-error":_vm.hasError,"padding-right":_vm.maxWidthStyle,"aria-describedby":_vm.typeAriaDescribedBy ? _vm.typeAriaDescribedBy : false},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}},'VueCurrencyInput',_vm.$attrs,false),_vm.inputListeners)):_vm._e(),_c('VueSelect',{attrs:{"id":`${_vm.uuid}-select`,"max-width":_vm.maxWidthSelect,"has-error":_vm.hasError},on:{"input":function($event){return _vm.$emit('input', _vm.model)}},model:{value:(_vm.model.type),callback:function ($$v) {_vm.$set(_vm.model, "type", $$v)},expression:"model.type"}},_vm._l((_vm.options),function(item,index){return _c('VueSelectOption',{key:item.key,attrs:{"text":item.value,"value":item.key,"index":index,"label-id":`${_vm.id}-option-${index}`}})}),1)],1),(_vm.addon)?_c('i',{attrs:{"id":_vm.computedAddonId}},[(_vm.addon)?_c('span',{staticClass:"sf-input-with-type__addon"},[_vm._v(_vm._s(_vm.addon))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []


// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-select/dist/vue-select.umd.js
var vue_select_umd = __webpack_require__(904);
// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-input/dist/vue-input.umd.js
var vue_input_umd = __webpack_require__(194);
var vue_input_umd_default = /*#__PURE__*/__webpack_require__.n(vue_input_umd);
// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-currency-input/dist/vue-currency-input.umd.js
var vue_currency_input_umd = __webpack_require__(477);
var vue_currency_input_umd_default = /*#__PURE__*/__webpack_require__.n(vue_currency_input_umd);
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInputWithType.vue?vue&type=script&lang=js&





const TYPES = {
	NORMAL: 'normal',
	CURRENCY: 'currency'
};
/* harmony default export */ const VueInputWithTypevue_type_script_lang_js_ = ({
	mixins: [c, N, a],
	inheritAttrs: false,
	name: 'VueInputWithType',
	data: () => ({
		model: {
			value: null,
			type: null
		}
	}),
	props: {
		options: {
			required: true,
			type: Array
		},
		/**
		The maximum width of the input
		 */
		maxWidth: {
			type: Number,
			required: false
		},
		/**
		Full width on mobile
		*/
		fullWidthMobile: {
			type: Boolean
		},
		/**
		The maximum width of the select
		 */
		maxWidthSelect: {
			type: Number,
			required: false
		},
		/**
		If set to currency it includes currency input instead of input
		@values normal, currency
		*/
		type: {
			required: false,
			default: TYPES.NORMAL
		},
		typeAriaDescribedBy: {
			type: String,
			required: false
		}
	},
	components: {
		VueInput: (vue_input_umd_default()),
		VueSelect: vue_select_umd.VueSelect,
		VueSelectOption: vue_select_umd.VueSelectOption,
		VueCurrencyInput: (vue_currency_input_umd_default())
	},
	computed: {
		TYPES: () => TYPES,
		inputListeners() {
			const vm = this;
			return Object.assign({}, this.$listeners, {
				input() {
					vm.$emit('input', vm.model);
				}
			});
		},
		maxWidthStyle() {
			return this.fullWidthMobile && this.isMobile && this.maxWidth ? null : `${this.maxWidth}px`;
		}
	},
	created() {
		if (this.options.length) {
			this.model.type = this.options[0].key;
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueInputWithType.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueInputWithTypevue_type_script_lang_js_ = (VueInputWithTypevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-59.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-59.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-59.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-59.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueInputWithType.vue?vue&type=style&index=3&id=49b0eb6a&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueInputWithType.vue?vue&type=style&index=3&id=49b0eb6a&prod&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueInputWithType.vue



;





/* normalize component */

var component = normalizeComponent(
  components_VueInputWithTypevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ const VueInputWithType = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueInputWithType);


})();

__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-input-with-type.umd.js.map